<!--
 * @Description:
 * @Autor: xiaona.wang
 * @Date: 2021-09-18 17:25:25
 * @LastEditors: xiaona.wang
 * @LastEditTime: 2021-11-09 18:41:18
-->
<template>
  <div id="Preview">
    <el-dialog v-dialogDrag :title="$t('code.preview')" :visible.sync="dialogVisible" width="30%">
      <div v-for="(item, index) in previews" :key="index" class="rxs">
        <div
          v-if="item.type == 'READ_ONLY'"
          class="rxleft"
          style="padding-top: 10px;"
        >
          {{ item.name }}
        </div>
        <div v-else  class="rxleft">
          <el-input v-model="item.name">
            {{ item.name }}
          </el-input>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisible = false">
          {{ $t("code.confirm") }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script type="text/javascript">
export default {
  name: "Preview",
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    previews: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {};
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("update:visible", val);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.rxs {
  width: 100%;
  height: auto;
}

.rxleft {
  width: auto;
  float: left;
  height: auto;
  margin-bottom: 0;
  margin-top: 10px;
  padding-right: 10px;
}
</style>
